import { useAtom } from "jotai";

import { aboutModalOpenAtom } from "./about-modal.state";

export const useAboutModal = () => {
  const [isAboutOpen, setIsAboutOpen] = useAtom(aboutModalOpenAtom);

  const openAboutModal = () => {
    setIsAboutOpen(true);
  };

  const closeAboutModal = () => {
    setIsAboutOpen(false);
  };

  return {
    isAboutOpen,
    openAboutModal,
    closeAboutModal,
  };
};
